const state = {
    notification_list: sessionStorage.getItem('notifications') ? JSON.parse(sessionStorage.getItem('notifications')) : [],
};

const mutations = {
    set_notification_list(state, payload) {
        state.notification_list.push(payload);
        sessionStorage.setItem('notifications', JSON.stringify(state.notification_list));
    },
    clear_notification_list(state) {
        state.notification_list = [];
        sessionStorage.removeItem('notifications');
    },
};

const getters = {
    notification_list() {
        return state.notification_list;
    },
};

const actions = {
    set_notification_list(context, payload) {
        context.commit('set_notification_list', payload);
    },
    clear_notification_list(context) {
        context.commit('clear_notification_list');
    },
};

export default {
    state,
    mutations,
    getters,
    actions,
};